<template>
	<v-card :elevation="1" class="flex round-card background-2">
        <v-card-title class="pa-3" style="white-space: nowrap">
			<p class="pl-2 pl-xl-3">Opportunità</p>
            <v-spacer></v-spacer>
            <v-select
                v-show="expand"
                v-model="filters['year']"
                :items="fieldsset.years"
                label="Anno"
                solo flat
                background-color="background-2"
                hide-details
                style="max-width: 100px"
                dense>
            </v-select>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="expand = !expand" :loading="loading" icon>
                        <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                    </v-btn>
                </template>                    
                <span>{{ expand ? 'Contrai' : 'Espandi' }}</span>
            </v-tooltip>
        </v-card-title>            
        <v-divider v-if="expand"></v-divider>

        <v-expand-transition>

            <div v-show="expand" id="opportunitiesstatus" class="px-2 round-card" ref="opportunitiesstatus" style="height: 450px">
            </div>

        </v-expand-transition>

    </v-card>

</template>

<script>

    import * as am4core from '@amcharts/amcharts4/core'
    import * as am4charts from '@amcharts/amcharts4/charts'
    import am4themes_dark from '@amcharts/amcharts4/.internal/themes/dark'
    import am4themes_material from '@amcharts/amcharts4/themes/material'
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    
    am4core.useTheme(am4themes_animated)

    export default {
        name: 'opportunities-status',
        props: {

        },

        data() {
            return {
                opportunities: [],
                expand: JSON.parse(localStorage.getItem('my_opportunities_status_'+this.$store.getters.getProfile.id)),
                loading: false,
                chart: {},
                fieldsset: {},
                filters: {},
            }
        },

        watch: {
            expand: {
                handler(newValue, oldValue) {
                    if(newValue == true) {                        
                        this.getData()
                    } else {
                        localStorage.setItem('my_opportunities_status_'+this.$store.getters.getProfile.id, JSON.stringify(false))
                    }
                },
                immediate: true
            },

            'filters.year' (newVal) {
                this.initialize()
            },

            '$vuetify.theme.dark' (newVal) {
                if(newVal) {
                    am4core.useTheme(am4themes_dark)
                    this.initialize()
                } else {
                    am4core.unuseTheme(am4themes_dark)
                    this.initialize()
                }
            }
        },

    
        methods: {

            getData() {
                this.getInfo().then(() => {
                    let first = _.first(this.fieldsset.years)
                    if(first) {
                        this.$set(this.filters, 'year', first.value)
                    }
                })
            },

            getInfo() {
                return new Promise((resolve, reject) => {
                    this.axios.get('myopportunities-info').then(response => {
                        // get body data
                        this.fieldsset = response.data.info

                        this.$store.commit('endProgress')
                        this.loaded = true
                        resolve()
                    }, response => {
                        // error callback
                        reject()
                    })
                })
            },

            initialize() {
                this.loading = true
                this.axios.post('myopportunities', this.filters).then(response => {
                    if (this._isBeingDestroyed || this._isDestroyed) return
                    if (!_.isEmpty(this.chart)) {
                        this.chart.dispose()
                    }
                    this.chart = am4core.create(this.$refs.opportunitiesstatus, am4charts.PieChart)
                    this.chart.hiddenState.properties.opacity = 0 // this creates initial fade-in
                    this.opportunities = response.data.data
                    this.chart.data = this.opportunities

                    this.chart.radius = am4core.percent(70)
                    this.chart.innerRadius = am4core.percent(40)
                    this.chart.startAngle = 180
                    this.chart.endAngle = 360  
                    this.chart.numberFormatter.numberFormat = "#.##";

                    let label = this.chart.seriesContainer.createChild(am4core.Label)
                    label.text = 'Totale'
                    label.horizontalCenter = 'middle'
                    label.verticalCenter = 'middle'
                    label.fontSize = 11
                    label.dy = -50
                    label.fill = am4core.color('#00E676')

                    let label2 = this.chart.seriesContainer.createChild(am4core.Label)
                    label2.text = '[bold]'+this.opportunities.reduce((acc, opportunity) => acc + opportunity.value, 0) + '[/]'
                    label2.horizontalCenter = 'middle'
                    label2.verticalCenter = 'middle'
                    label2.fontSize = 24
                    label2.dy = -30
                    label2.fill = am4core.color('#00E676')


                    let series = this.chart.series.push(new am4charts.PieSeries())
                    series.dataFields.value = 'value'
                    series.dataFields.category = 'status_text'

                    series.slices.template.cornerRadius = 10
                    series.slices.template.innerCornerRadius = 7
                    series.slices.template.draggable = true
                    series.slices.template.inert = true
                    series.alignLabels = false


                    series.hiddenState.properties.startAngle = 90
                    series.hiddenState.properties.endAngle = 90
                    series.slices.template.tooltipText = "[font-size: 12px]{status_text}: {value.percent}% ({value})[/]"
                    series.labels.template.text = "[font-size: 11px]{category}: {value.percent} %[/]"

                    this.chart.legend = new am4charts.Legend()
                    let markerTemplate = this.chart.legend.markers.template;
                    markerTemplate.width = 10;
                    markerTemplate.height = 10;
                    this.chart.legend.labels.template.text = "[font-size: 11px]{status_text}:[/]"
                    series.legendSettings.valueText = "[font-size: 11px]{value.percent} %[/]"
                    
                    localStorage.setItem('my_opportunities_status_'+this.$store.getters.getProfile.id, JSON.stringify(true))
                    this.loading = false
                }, response => {
                    // error callback
                })                
            }
        },

        created() {
            if(this.$vuetify.theme.dark) {
                am4core.useTheme(am4themes_dark)
            } else {
                am4core.unuseTheme(am4themes_dark)
            }
        },

        beforeDestroy() {
            if (this.chart && !_.isEmpty(this.chart)) {
                this.chart.dispose()
            }
        },
    }
</script>
<style>
    .v-toolbar__content {
        padding-left: 8px !important;
    }
</style>